import React from "react";

const GenericWrapper: React.FC = ({children}) => {
	return (
		<div id="cih-layout">
			{children}
		</div>
	);
};

export default GenericWrapper;
